import {
  FontWeight,
  HeadingVariant,
  LiliButton,
  LiliButtonType,
  Heading,
} from '@lili/lili-frontend-common';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Icons } from '@Components/icon/Icon';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { useBoundStore } from '@Store/index';
import { RoutesMap } from '@Router/router.types';
import { useNavigationManager } from '@Router/useNavigationManager';

export const RecoverySuccess = () => {
  const { isMobile } = useResizeListener();
  const { clearSlice } = useBoundStore.getState().resetPasswordSlice;
  const { t } = useTranslation();
  const { navigateToSpecificPage } = useNavigationManager();

  useEffect(() => {
    clearSlice();
  }, []);
  return (
    <div className='w-full h-full flex flex-col items-center justify-center'>
      <div className='w-full px-[18px] md:w-[400px] flex flex-col items-center justify-center'>
        <Icon icon={Icons.Checkmark} className='mb-[40px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header'>
          {t('recovery.recoverySuccess.title')}
        </Heading>
        <Heading.H10
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-secondary text-center mb-[24px]'>
          {t('recovery.recoverySuccess.subtitle')}
        </Heading.H10>
        <LiliButton
          type={LiliButtonType.PRIMARY}
          id='recovery-success-go-to-login'
          title={t('recovery.recoverySuccess.cta')}
          className='mt-[40px]'
          onClick={() => navigateToSpecificPage(RoutesMap.WELCOME)}
        />
      </div>
    </div>
  );
};
